/*
 * @Author: xiaosiyu
 * @Date: 2021-06-30 13:45:13
 * @LastEditors: xiaosiyu
 * @LastEditTime: 2021-07-26 14:55:12
 * @Description: file content
 */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getRegionCodeOriginData } from './fetch';
import errorboundary from '@liepin/cnpm-react-errorboundary-fe';
import { hotData, getChartCode, getNameFirstWord } from './utils';
import './index.less'

const RegionCode = errorboundary()((props) => {
  const { onChange, style } = props;

  const [data, setData] = useState({});
  const [charData, setCharData] = useState([])

  useEffect(() => {
    async function fetchRegionCodeData () {
      try {
        const status = await getRegionCodeOriginData();

        if (status.flag === 1 && status.data) {
          const chartArr = getChartCode();
          const temp = {};
          const normal = status.data.normal;
          for (var i of chartArr) {
            let filterData = normal.filter(v => getNameFirstWord(v.pinyin).toLocaleUpperCase() === i);
            if (filterData && filterData.length) {
              temp[i] = filterData
            }
          }
          setData(status.data)
          setCharData(temp)
        } else {
          setData({ hot: hotData })
        }
      } catch (error) {
        setData({ hot: hotData })
        throw Error(error)
      }
    }
    fetchRegionCodeData();
  }, [])

  const charKeys = Object.keys(charData) || [];

  return (
    <div className="lp-region-code" style={style}>
      <div className="lp-region-code-item-hot">
        <span className="lp-region-code-title">热门</span>
        <ul className="lp-region-code-list">
          {
            data.hot && data.hot.map((item, index) => {
              return (
                <li key={index} className="lp-region-code-list-item" onClick={() => onChange && onChange(item)}>
                  <span>{item.name}</span>
                  <span>{`${item.codeShow}`}</span>
                </li>
              )
            })
          }
        </ul>
      </div>
      {
        charKeys.map((item, index) => {
          return (
            <div key={index} className="lp-region-code-item">
              <span className="lp-region-code-title">{item}</span>
              <ul className="lp-region-code-list">
                {
                  charData[item] && charData[item].map((k, i) => {
                    return (
                      <li key={i} className="lp-region-code-list-item" onClick={() => onChange && onChange(k)}>
                        <span className="lp-region-code-list-item-name">{k.name}</span>
                        <span>{`${k.codeShow}`}</span>
                      </li>
                    )
                  })
                }
              </ul>
            </div>
          )
        })
      }
    </div>
  )
})

export default RegionCode


RegionCode.propTypes = {
  style: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};
